import aboutImg from "../images/about.jpeg";
import Title from "./Title";
const About = () => {
  return (
    <>
      <section className='section' id='about'>
        <Title Text1='about' Text2='us' />

        <div className='section-center about-center'>
          <div className='about-img'>
            <img src={aboutImg} className='about-photo' alt={"awesome beach"} />
          </div>
          <article className='about-info'>
            <h3>explore the difference</h3>
            <p>
            TechSoluGH is a provider of comprehensive IT solutions, specializing in delivering, supporting, 
            and setting up cutting-edge IT infrastructures for businesses. 
            </p>
            <p>
             We offer a range of services that enable organizations to leverage 
             technology effectively, streamlining their operations, and achieving their strategic objectives.
            </p>
            <a href='#about' className='btn'>
              read more
            </a>
          </article>
        </div>
      </section>
    </>
  );
};
export default About;
